(function($, Routing, Translator, growl_message, error_message) {
    $(document).ready(function() {
        const $favoriteCounter = document.querySelector('.favorites__counter');
        $('body')
            .on('click', '.add-to-wishlist-btn', function(e) {
                e.preventDefault();
                var filmId = $(this).data('film-id'),
                    icon = $('.add-to-wishlist-btn[data-film-id=' + filmId + ']'),
                    before = function() {
                        icon.removeClass('add-to-wishlist-btn');
                        icon.addClass('active');
                    },
                    reset = function() {
                        icon.addClass('add-to-wishlist-btn');
                        icon.addClass('active');
                    },
                    after = function(data) {
                        icon.addClass('remove-from-wishlist-btn');
                        icon.find('i.fa-heart-o')
                            .removeClass('fa-heart-o')
                            .addClass('fa-heart');
                        icon.parent().addClass('wishlist-active');
                        icon.attr('title', Translator.trans('film.remove_from_wishlist', {}, 'messages'))
                        if ($favoriteCounter) {
                            $favoriteCounter.innerHTML = data;
                        }
                    };
                $.ajax({
                    url: Routing.generate('user_wishlist_add', {filmId: filmId}),
                    beforeSend: before(),
                    statusCode: {
                        201: function(data) {
                            // Film added
                            growl_message(Translator.trans('film.added_in_wishlist', {}, 'messages'));
                            after(data);
                        },
                        401: function() {
                            // User not connected
                            error_message(Translator.trans('film.add_in_wishlist.user.not_connected', {}, 'messages'));
                            reset();
                        },
                        404: function() {
                            // Film not found
                        },
                        409: function() {
                            // Already in the wishlist
                        }
                    }
                });
            })
            .on('click', '.remove-from-wishlist-btn', function(e) {
                e.preventDefault();
                var filmId = $(this).data('film-id'),
                    icon = $('.remove-from-wishlist-btn[data-film-id=' + filmId + ']'),
                    before = function() {
                        icon.removeClass('remove-from-wishlist-btn');
                        icon.removeClass('active');
                    },
                    reset = function() {
                        icon.addClass('remove-from-wishlist-btn');
                        icon.removeClass('active');
                    },
                    after = function(data) {
                        icon.find('i.fa-heart')
                            .removeClass('fa-heart')
                            .addClass('fa-heart-o');
                        icon.parent().removeClass('wishlist-active');
						icon.addClass('add-to-wishlist-btn');
                        icon.attr('title', Translator.trans('film.add_in_wishlist', {}, 'messages'));
                        setTimeout(() => {
                            icon
                                .closest(".film-item")
                                .fadeOut("300")
                            ;
                        }, 3000);

                        if ($favoriteCounter) {
                            $favoriteCounter.innerHTML = data;
                        }
                    };
                $.ajax({
                    url: Routing.generate('user_wishlist_remove', {filmId: filmId}),
                    beforeSend: before(),
                    statusCode: {
                        200: function(data) {
                            // Film removed
                            growl_message(Translator.trans('film.removed_from_wishlist', {}, 'messages'));
                            after(data);
                        },
                        401: function() {
                            // User not connected
                            error_message(Translator.trans('film.remove_in_wishlist.user.not_connected', {}, 'messages'));
                            reset();
                        },
                        404: function() {
                            // Film not found
                        }
                    }
                });
            });
    });
})(jQuery, Routing, Translator, growl_message, error_message);